import React from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useGA4CommonParameters } from "scmp-sdk/components/rosetta/hooks";
import { SubscriptionButton } from "scmp-sdk/components/rosetta/subscription-button/styles";

type Props = {
  className?: string;
};
export const EpaperButton: React.FunctionComponent<Props> = ({ className }) => {
  const { handleTrackGA4 } = useSdkContext();
  const { computeGA4CommonParameters } = useGA4CommonParameters();
  /*
   * No masthead subs_entry_point_imp is required for EPAPER button
   * Is enter products page rather than lead to a subscription action
   */
  return (
    <SubscriptionButton
      className={className}
      onClick={() => {
        handleTrackGA4({
          action: "click",
          category: "epaper",
          customized_parameters: {
            call_to_action: "read epaper",
            ...computeGA4CommonParameters(),
            trigger_point: "masthead",
          },
          subcategory: "",
        });
        globalThis.location.href = "/epaper";
      }}
    >
      Read ePaper
    </SubscriptionButton>
  );
};

EpaperButton.displayName = "EpaperButton";
